module.exports = {"id":"test","element":"div","attribute":"data-trackname","tab":"navbarItemTest","columns":[{"text":"title","type":"string","sortable":true,"filterable":true},{"name":"Description","type":"string","text":"description","sortable":true,"filterable":true}],"options":{"filterByColumn":true,"draggable":true,"details":["title"]}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Index/table_ItemsTJ.json
// module id = H8yS
// module chunks = 0